<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <b-form @submit="onSubmit" @reset="onReset" novalidate="novalidate">
                    <div class="card">
                        <div class="card-header card-header-icon card-header-rose">
                            <div class="card-icon">
                                <i class="material-icons">download</i>
                            </div>
                            <h4 class="card-title">Baixar arquivo</h4>
                        </div>
                        <div class="card-body">
                            <div class="row" v-if="hasErrors">
                                <div class="col-md-12">
                                    <b-list-group>
                                        <b-list-group-item variant="danger" v-for="err in errors">{{ err }}</b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12">
                                    <div 
                                        class="form-group"
                                        v-bind:class="{'has-danger' : validation.file != '' }">
                                        <file-upload
                                            class="btn btn-primary"
                                            :multiple="false"
                                            :size="1024 * 1024 * 10"
                                            v-model="files"
                                            @input-filter="inputFilter"
                                            @input-file="inputFile"
                                            ref="upload">
                                            <i class="fa fa-plus"></i>
                                            Selecione a Planilha
                                        </file-upload>
                                        <label v-if="validation.file != ''" id="file-error" class="error" for="file" style="clear: both; display: block;">{{ validation.file }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Baixar</button>
                        </div>
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                contentTypeAccepts: [
                    "application/vnd.ms-excel",
                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    "application/wps-office.xls",
                    "application/wps-office.xlsx",
                    "application/excel",
                    "application/x-excel",
                    "application/x-msexcel"
                ],
                errors: [],
                files: [],
                form: {
                    file: {
                        name: '',
                        contentType: '',
                        content: ''
                    }
                },
                hasErrors: false,
                validation: {
                    file: ""
                }
            };
        },
        methods: {
            getBase64(file) {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = () => resolve(window.btoa(reader.result));
                    reader.onerror = error => reject(error);
                });
            },
            inputFile(newFile, oldFile) {
                var form = this.form;
                const reader = new FileReader();

                form.file = {
                    name: '',
                    contentType: '',
                    content: ''
                };
                if (newFile && !oldFile) {
                    const file = this.getBase64(newFile.file);

                    file.then(function (data) {
                        form.file = {
                            name: newFile.name,
                            contentType: newFile.type,
                            content: data
                        };
                    });
                }
                if (newFile && oldFile) {
                    // update
                    console.log('update', newFile)
                }
                if (!newFile && oldFile) {
                    // remove
                    console.log('remove', oldFile)
                }
            },
            inputFilter(newFile, oldFile, prevent) {
                if (newFile && !oldFile) {
                    // Before adding a file
                    // 添加文件前
                    // Filter system files or hide files
                    // 过滤系统文件 和隐藏文件
                    if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
                        return prevent()
                    }
                    // Filter php html js file
                    // 过滤 php html js 文件
                    if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
                        return prevent()
                    }
                }
            },
            onReset: function (_ev) {
                _ev.preventDefault();

                this.files = [];
                this.validation.file = "";

                this.form.file = {
                    name: '',
                    contentType: '',
                    content: ''
                };
            },
            onSubmit: function (_ev) {
                _ev.preventDefault();

                var self = this;
                var valid = true;
                self.validation.file = "";

                if (self.form.file.name === "") {
                    self.validation.file = "Selecione a Planilha";
                    valid = false;
                } else if (self.contentTypeAccepts.indexOf(self.form.file.contentType) === -1) {
                    self.validation.file = "Formato inválido!";
                    valid = false;
                }

                if (valid) {
                    self.$root.$emit("onLoading");

                    const response = self.$store.dispatch("downloadBills/execute", self.form);

                    response.then(response => {
                        self.$root.$emit("onLoading");
                        if (response.status === undefined) {
                            let contentType = response.headers["content-type"];
                            let contentDisposition = response.headers["content-disposition"];
                            const regex = /filename=([^;]+)/;
                            const match = contentDisposition.match(regex);
                            const fileName = match[1];
                            
                            let blob = new Blob([response.data], {type: contentType});

                            let link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click();
                        } else if (response.status != 200) {
                            alert("Nenhum boleto disponível para download!");
                            self.$root.$emit("onLoading");
                            return;
                        }
                    });

                    response.catch(function (_errors) {
                        console.log('--->');
                        let contentType = _errors.headers["content-type"];
                        let blob = new Blob([_errors.data], {type: contentType});
                        var fr = new FileReader();
                        fr.onload = function() {
                            var responseErro = JSON.parse(this.result);
                            alert(responseErro.message);
                        };

                        fr.readAsText(blob);
                        self.$root.$emit("onLoading");
                    });
                }
            },
            showErrors: () => {
                var self = this;
        
                self.hasErrors = true;
            }
        }
    };
</script>
